import { translate } from 'loankeeper-common/helpers'

export default (key) => translate(`frm_sec_RL_add_edit-${key}`)
export const translateLKMessage = (key) => translate(`LKMESSAGE-${key}`)
